import { useEffect, useRef, useState } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { api, ApiError } from '@/lib/api';
import { useAuth } from '@/auth/AuthContext';

export function AuthCallbackPage() {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const [status, setStatus] = useState<'pending' | 'success' | 'error'>('pending');
  const [message, setMessage] = useState<string | null>(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Missing token in URL.');
      return;
    }
    (async () => {
      try {
        await api.callback(token);
        await refresh();
        setStatus('success');
      } catch (err) {
        const msg = err instanceof ApiError ? err.message : 'Sign-in failed.';
        setStatus('error');
        setMessage(msg);
      }
    })();
  }, [params, refresh]);

  if (status === 'success') return <Navigate to="/" replace />;

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6 text-sm">
      {status === 'pending' && <p className="text-muted-foreground">Signing you in...</p>}
      {status === 'error' && (
        <div className="rounded-md border border-destructive/30 bg-destructive/5 p-4 text-destructive">
          {message}
        </div>
      )}
    </div>
  );
}
